<template>
  <div>
    <v-container fluid>
      <confirm-dialog v-model="removePromiseGetter"/>
      <v-data-table
          :headers="headers"
          :items="data"
          :items-per-page="itemsPerPage"
          :loading="loading"
          :page.sync="page"
          :search="search"
          class="elevation-1"
          @page-count="pageCount = $event"
          hide-default-footer
      >
        <template v-slot:top>
          <v-toolbar flat>
            <search @search="searchItem($event)"/>
            <v-spacer></v-spacer>
            <v-btn v-show="$store.getters.checkAccess({permission:'USERS', c: true})"
                   @click="editUser()" color="primary"
            >Create new user
            </v-btn>
          </v-toolbar>
          <v-divider></v-divider>
        </template>
        <template v-slot:item.active="{ item }">
          <v-switch inset v-model="item.active" readonly></v-switch>
        </template>
        <template v-slot:item.adds="{ item }">
          <v-chip v-for="setting in item.exchangerSettings" class="ml-2">
              {{setting.coinPair.pair}}
          </v-chip>
        </template>
        <template v-slot:item.rating="{ item }">
          <v-rating
              v-model="rating"
              color="primary"
              readonly
          ></v-rating>
        </template>
        <template v-slot:item.actions="{ item }">
          <div class="text-right">
            <v-btn class="mx-2" color="primary" dark fab x-small @click="editUser(item)"
                   v-show="$store.getters.checkAccess({permission:'USERS', u: true})">
              <v-icon dark>edit</v-icon>
            </v-btn>
            <v-btn class="mx-2" color="primary" dark fab x-small @click="deleteUser(item)"
                   v-show="$store.getters.checkAccess({permission:'USERS', d: true})">
              <v-icon dark>delete</v-icon>
            </v-btn>
          </div>
        </template>
      </v-data-table>
    </v-container>
  </div>
</template>

<script>
import rules from "../api/rules";
import {mapGetters} from "vuex";
import CustomForm from "@/components/CustomForm";

export default {
  name: "Users",
  components: {CustomForm},
  data: () => ({
    search: '',
    pagVal: [10, 20, 50, 100],
    loading: false,
    dialog: false,
    valid: false,
    page: 1,
    pageCount: 0,
    itemsPerPage: 999999,
    model: {},
    rules: rules,
    saveLoading: false,
    apiKeyDialog: false,
    currentApiKey: "",
    removePromiseGetter: null,
    rating: 5,

    headers: [
      {text: 'ID', value: 'id'},
      {text: 'username', value: 'name'},
      {text: 'active', value: 'active'},
      {text: 'rating', value: 'rating'},
      {text: 'adds', value: 'adds'},
      {text: '', value: 'actions', sortable: false},
    ],
    data: [],
    roles: [],
    statuses: [],
  }),
  computed: {
    ...mapGetters(['checkAccess', "user"]),
    fields() {
      const fields = {
        username: {
          label: 'username',
          type: String,
          disabled: !!this.model?.id,
          rules: !this.model?.id ? [
            s => !!s || 'Required field',
            s => !!s && s.length >= 6 && s.length <= 20 || 'Username should be more then 6 chars and less then 20 chars',
            s => !!s && /^[a-zA-Z0-9_]+$/.test(s) || 'Only latin letter or numbers'
          ] : []
        },
        email: {
          label: 'email',
          type: String,
          rules: [
            this.rules.required,
            this.rules.email,
          ]
        },
        phone: {
          label: 'phone',
          type: String,
          rules: [
            this.rules.required
          ]
        },
        roles: {
          label: 'roles',
          type: Array,
          text: 'name',
          multiple: true,
          rules: [rules.requiredArray],
          items: this.roles,
        },
      }
      if (!this.model?.id) {
        fields.password = {
          type: String,
          label: 'password',
          rules: this.passwordRules,
          cols: '6',
          password: true,
        };
        fields.verifyPassword = {
          type: String,
          label: 'verify password',
          rules: [
            this.model.password === this.model.verifyPassword || "Passwords do not match",
          ],
          cols: '6',
          password: true,
        }
      }

      return fields;
    },
  },
  methods: {
    searchItem(event) {
      this.search = event
      this.data = this.data.sort((a, b) => {
        const nameA = a.name.toLowerCase();
        const nameB = b.name.toLowerCase();
        const queryLower = event.toLowerCase();

        const startsWithA = nameA.startsWith(queryLower);
        const startsWithB = nameB.startsWith(queryLower);

        if (startsWithA && !startsWithB) return -1;
        if (!startsWithA && startsWithB) return 1;

        const includesA = nameA.includes(queryLower);
        const includesB = nameB.includes(queryLower);

        if (includesA && !includesB) return -1;
        if (!includesA && includesB) return 1;

        return 0; // Если совпадений нет, сохранить исходный порядок
      });
    },
    initialize() {
      this.data = [];
      this.dialog = false;
      this.loading = true
      this.$http.get("/user")
          .then(
              r => {
                this.data = r.data
              }, e => this.$store.dispatch('setGlobalErrorMessage', e.response.data)
          )
          .finally(() => this.loading = false);

    },
  },
  created() {
    this.initialize()
  },
};
</script>

<style scoped>

</style>